import * as React from 'react';
import BuilderContent from './BuilderContent';
import BuilderSmartInsight from './BuilderSmartInsight';
import BuilderSmartNote from './BuilderSmartNote';

export interface IBuilderProps {}

function Builder(props: IBuilderProps) {
  return <React.Fragment />;
}
Builder.Content = BuilderContent;
Builder.SmartInsight = BuilderSmartInsight;
Builder.SmartNote = BuilderSmartNote;

export default Builder;
